import './styles/app.scss';
import { Route, Routes } from 'react-router-dom';
import { Header } from './modules/Header/header';
import { About } from './modules/About/about';
import { useEffect, useState } from 'react';
import { Documents } from './modules/Documents/documents';
import { Services } from './modules/Services/services';

function App() {
  const [cookieAccepted, setCookieAccepted] = useState(false);

  useEffect(() => {
    const loadScripts = async () => {
      try {
        await loadScript("https://lidrekon.ru/slep/js/jquery.js", 'slep-js-jquery');
        await loadScript("https://lidrekon.ru/slep/js/uhpv-full.min.js", 'uhpv-full');
      } catch (error) {
        console.error("Error loading scripts:", error);
      }
    };

    const loadScript = (src: string, id: string) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.id = id;
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    loadScripts();
    return () => {
      const elementScriptFirst = document.body.querySelector('script[src="https://lidrekon.ru/slep/js/jquery.js"]');
      const elementScriptSecond = document.body.querySelector('script[src="https://lidrekon.ru/slep/js/uhpv-full.min.js"]');

      if (!elementScriptFirst || !elementScriptSecond) return;
      // Clean up on component unmount
      document.body.removeChild(elementScriptFirst);
      document.body.removeChild(elementScriptSecond);
    };
  }, []);

  const handleAcceptCookies = () => {
    localStorage.setItem('cookieAccepted', 'true');
    setCookieAccepted(true);
  };

  return (
    <>
      <div className="App">
        <Header />
        <main className='main'>
          <Routes>
            <Route path='/about' element={<About />} />
            <Route path='/documents' element={<Documents/>}/>
            <Route path='/services' element={<Services/>}/>
            <Route path='/' element={<Services/>}/>
          </Routes>
        </main>
      </div>
      {!cookieAccepted && (
        <div className="cookie-banner" role="dialog" aria-live="polite">
          <div className="cookie-banner__content">
            <p className="cookie-banner__text">
              Используя этот сайт, вы соглашаетесь с использованием файлов cookie. Мы используем cookie для корректной работы сайта и отображения интерактивной карты расположения клиники. Некоторые cookie могут устанавливаться сторонними сервисами, включая Яндекс Карты. Продолжая пользоваться сайтом, вы соглашаетесь с обработкой технических данных в соответствии с <a href="assets/files/politika-cookie.pdf" target="_blank" rel="noopener noreferrer">Политикой использования файлов Cookie</a>, <a href="assets/files/user-agreement.pdf" target="_blank" rel="noopener noreferrer">Пользовательским соглашением</a> и <a href="assets/files/personal-data.pdf" target="_blank" rel="noopener noreferrer">Политикой обработки персональных данных</a>.
            </p>
            <button className="cookie-banner__button" onClick={handleAcceptCookies}>
              Принять
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default App;
